// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
import * as Types from './generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RefundFieldsFragment = { __typename?: 'Refund', id: string, amount: number, payment_id: string, status: Types.RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: Types.StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null };

export type CreateRefundMutationVariables = Types.Exact<{
  data: Types.CreateRefundInput;
}>;


export type CreateRefundMutation = { __typename?: 'Mutation', createRefund: { __typename?: 'Refund', id: string, amount: number, payment_id: string, status: Types.RefundStatus, approved_by_name: string, user_reason: string, stripe_reason?: Types.StripeRefundReason | null, created_at: number, cancelled_at?: number | null, error?: { __typename?: 'PaymentError', message: string } | null, created_by: { __typename?: 'User', first_name?: string | null, last_name?: string | null }, cancelled_by?: { __typename?: 'User', first_name?: string | null, last_name?: string | null } | null } };

export const RefundFieldsFragmentDoc = gql`
    fragment RefundFields on Refund {
  id
  amount
  payment_id
  status
  approved_by_name
  user_reason
  stripe_reason
  error {
    message
  }
  created_by {
    first_name
    last_name
  }
  cancelled_by {
    first_name
    last_name
  }
  created_at
  cancelled_at
}
    `;
export const CreateRefundDocument = gql`
    mutation createRefund($data: CreateRefundInput!) {
  createRefund(data: $data) {
    ...RefundFields
  }
}
    ${RefundFieldsFragmentDoc}`;
export type CreateRefundMutationFn = Apollo.MutationFunction<CreateRefundMutation, CreateRefundMutationVariables>;

/**
 * __useCreateRefundMutation__
 *
 * To run a mutation, you first call `useCreateRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRefundMutation, { data, loading, error }] = useCreateRefundMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateRefundMutation(baseOptions?: Apollo.MutationHookOptions<CreateRefundMutation, CreateRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRefundMutation, CreateRefundMutationVariables>(CreateRefundDocument, options);
      }
export type CreateRefundMutationHookResult = ReturnType<typeof useCreateRefundMutation>;
export type CreateRefundMutationResult = Apollo.MutationResult<CreateRefundMutation>;
export type CreateRefundMutationOptions = Apollo.BaseMutationOptions<CreateRefundMutation, CreateRefundMutationVariables>;